<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
    name: 'CreateModal',
    props:[
        "list"
    ],
    data() {
      return {
        form: {},
        submitted: false,
        loading: false,
      };
    },
    validations: {
    form: {
      nasname: { required },
      shortname: { required },
      username: { required },
      password: { required },
      secret: { required },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
    }
  },
  methods: {
    testConnect(){
      this.loading = true;
       this.$http.post('/routers/test', { 
        nasname : this.form.nasname, 
        password : this.form.password, 
        username : this.form.username, 
        })
        .then(resp => {
          this.loading = false;
          if(resp.data.error) return notify.error(resp.data.message)

          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    handleSubmit() {
      this.submitted = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return;
      } else {
        
        if(this.form.id)
          this.update();
          else
          this.create();

          this.$emit('loadItems');
      }
      this.submitted = false;
    },
    create(){
      this.$http.post('/routers/store', this.form)
        .then(resp => {
          this.form = {};
          this.loading = false;
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    update(){
      this.$http.put('/routers/' + this.form.id , {
        id: this.form.id,
        nasname: this.form.nasname,
        password: this.form.password,
        secret: this.form.secret,
        shortname: this.form.shortname,
        status_id: this.form.status_id,
        username: this.form.username,
        })
        .then(resp => {
          this.loading = false;
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
      this.$http.delete('/routers/' + id)
        .then(resp => {
          this.loading = false;
          if(resp.data.code !==  100)  return notify.error(resp.data.message)
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    }
  },
};
</script>
<template>
  <b-modal id="modal-scoped" title="Router Ekle"  no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="nasname">Router İp</label>
              <input
                id="nasname"
                v-model="form.nasname"
                type="text"
                class="form-control"
                placeholder="Router İp"
                :class="{
                  'is-invalid': submitted && $v.form.nasname.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.nasname.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="shortname">Router Adı</label>
              <input
                id="shortname"
                v-model="form.shortname"
                type="text"
                class="form-control"
                placeholder="Router Adı"
                :class="{
                  'is-invalid': submitted && $v.form.shortname.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.shortname.required"
                class="invalid-feedback"
              >
               Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="username">Router Kullanıcı Adı</label>
              <input
                id="username"
                v-model="form.username"
                type="text"
                class="form-control"
                placeholder="Router Kullanıcı Adı"
                :class="{
                  'is-invalid': submitted && $v.form.username.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.username.required"
                class="invalid-feedback"
              >
               Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="password">Router Password</label>
              <input
                id="password"
                v-model="form.password"
                type="text"
                class="form-control"
                placeholder="Router Password"
                :class="{
                  'is-invalid': submitted && $v.form.password.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.password.required"
                class="invalid-feedback"
              >
               Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
           <div class="col-12">
            <div class="mb-3">
              <label for="secret">Router Secret</label>
              <input
                id="secret"
                v-model="form.secret"
                type="text"
                class="form-control"
                placeholder="Router Secret"
                :class="{
                  'is-invalid': submitted && $v.form.secret.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.secret.required"
                class="invalid-feedback"
              >
               Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <div class="form-check form-check-success mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="formsuccess"
                  checked=""
                  v-model="form.status_id"
                />
                <label class="form-check-label" for="formsuccess">
                  Aktif
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            :disabled="loading"
            >
             <span v-if="loading"> 
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> Bekleyiniz 
            </span>
            <span v-else>Oluştur
            </span>
          </b-button>
           <b-button 
            type="button" 
            @click="testConnect()"
            variant="info" 
            class="ms-1"
            :disabled="loading"
            >
            <span v-if="loading"> 
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> Bekleyiniz 
            </span>
            <span v-else>
             Bağlantıyı Test Et
            </span>
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>